import { Tag, TagLabel } from "@chakra-ui/react";
import { FC } from "react";
import { InvoiceStatus as InvoiceStatusEnum } from "types/invoice";

const InvoiceStatus: FC<{ status: InvoiceStatusEnum }> = ({ status }) => {
  const getStatusColor = (status: InvoiceStatusEnum): string => {
    switch (status) {
      case InvoiceStatusEnum.ACTIVE:
        return "green";
      case InvoiceStatusEnum.WAITING:
      case InvoiceStatusEnum.WAITING_METHOD:
        return "yellow";
      case InvoiceStatusEnum.SUCCESS:
        return "cyan";
      case InvoiceStatusEnum.ARCHIVED:
        return "gray";
      case InvoiceStatusEnum.EXPIRED:
        return "red";
      case InvoiceStatusEnum.CANCELED:
        return "pink";
      default:
        return "gray";
    }
  };

  return (
    <Tag size="md" variant="solid" colorScheme={getStatusColor(status)}>
      <TagLabel>{status}</TagLabel>
    </Tag>
  );
};

export default InvoiceStatus;
